import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import HolidayPicker from "../../components/HolidayPicker/HolidayPicker";

const DashboardTablePage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <HolidayPicker />
                </div>
            </div>
        </div>
    );
};

export default DashboardTablePage;
